var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnnounce = function SvgAnnounce(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#412D09",
    clipPath: "url(#announce_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.09 11.56c0-1.16-.52-2.24-1.35-2.82a.74.74 0 0 0-1.04.19c-.24.34-.15.81.19 1.04.43.3.71.93.71 1.59 0 .71-.3 1.35-.78 1.63-.36.21-.47.67-.26 1.03.14.23.39.37.64.37.13 0 .26-.03.38-.11.93-.56 1.51-1.67 1.51-2.92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.49 7.08a.74.74 0 0 0-1.04.19c-.24.34-.15.81.19 1.04.9.62 1.45 1.84 1.45 3.18 0 1.41-.63 2.69-1.6 3.27-.36.21-.47.67-.26 1.03.14.23.39.37.64.37.13 0 .26-.03.38-.11 1.43-.86 2.33-2.6 2.33-4.56 0-1.82-.8-3.51-2.09-4.41M18.55 11.59c0-.95-.55-1.73-1.27-1.87-.04-1.2-.09-2.41-.2-3.61-.08-.77-.49-1.39-1.14-1.68-.68-.31-1.51-.2-2.17.28-1.54 1.08-3.24 1.71-5.04 2.33v8.97c1.79.62 3.49 1.25 5.03 2.33.42.3.9.45 1.36.45.28 0 .56-.06.82-.17.65-.29 1.06-.9 1.14-1.69.1-1.15.16-2.31.19-3.47.72-.15 1.27-.92 1.27-1.87zM2.17 9.76v3.6c0 1.32 1.08 2.39 2.39 2.39h3.05v-8.4H4.58c-1.33 0-2.42 1.09-2.42 2.42zM7.57 18.58c-.22-.58-.34-1.16-.37-1.72H4.72c.04.74.25 1.52.63 2.28.17.34.54.57.87.57h.84c.52 0 .71-.57.51-1.12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.84 15.76a.85.85 0 0 1-.12-.36H4.23c0 .1.04.21.1.32.82.02 1.66.03 2.51.04"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "announce_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h24v24H.5z"
  })))));
};
export default SvgAnnounce;